import { useState } from "react";
import { Image, Skeleton, type ImageProps } from "@chakra-ui/react";

interface FadingImageProps extends ImageProps {
  skeletonStartColor?: string;
  skeletonEndColor?: string;
}

export default function FadingImage({
  skeletonStartColor = "colors.gray.100",
  skeletonEndColor = "colors.gray.200",
  style,
  onLoad,
  ...props
}: FadingImageProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <Skeleton
          position="absolute"
          inset={0}
          w="100%"
          h="100%"
          css={{
            "--start-color": skeletonStartColor,
            "--end-color": skeletonEndColor,
          }}
        />
      )}

      <Image
        loading="lazy"
        decoding="async"
        {...props}
        onLoad={(e) => {
          setLoaded(true);
          onLoad?.(e as React.SyntheticEvent<HTMLImageElement>);
        }}
        style={{
          ...style,
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.6s ease",
        }}
      />
    </>
  );
}